module.exports = __webpack_public_path__ + "img/pedding-bg.3ea7d19c.svg";